export default __webpack_public_path__ + "static/media/undraw_Add_tasks.46be6700.svg";